import * as _typeDetect2 from "type-detect";
var _typeDetect = "default" in _typeDetect2 ? _typeDetect2.default : _typeDetect2;
var exports = {};
const type = _typeDetect,
  escapedRegex = /[\\/|#<>{}()[\]^$+\-*?,.:!%]/g,
  RegexEscaped = e => "string" === type(e) ? e.trim().replace(escapedRegex, "\\$&") : e,
  _fixRegexStickyTest = e => {
    e.nonStickyTest = t => {
      e.lastIndex = 0;
      let s = e.test(t);
      return e.lastIndex = 0, s;
    };
  };
exports = {
  RegexEscaped,
  FixRegexStickyTest: _fixRegexStickyTest
};
export default exports;